'use client';

import * as React from 'react';
import styles from './styles.module.scss';
import Link from 'next/link';
import Image from 'next/image';

export interface IHeaderTicketProps {
  label: string;
  tickets: number;
  imageUrl: string;
  href: string;
}

export interface IHeaderTicketsProps {
  tickets: IHeaderTicketProps[];
  buttons?: React.ReactNode;
}

const HeaderTicket: React.FunctionComponent<IHeaderTicketProps> = (props) => {
  return (
    <li>
      <Link
        href={props.href}
        className={styles['header-ticket']}
        draggable={false}
        prefetch={false}
      >
        <div className={styles['header-ticket__image']}>
          <Image
            src={props.imageUrl}
            alt={props.label}
            width={18}
            height={18}
          />
        </div>
        <div className={styles['header-ticket__label']}>{props.label}</div>
        <div className={styles['header-ticket__tickets']}>{props.tickets}</div>
      </Link>
    </li>
  );
};

const HeaderTickets: React.FunctionComponent<IHeaderTicketsProps> = (props) => {
  if (props.tickets.length === 0) {
    return null;
  }

  return (
    <ul className={styles['header-tickets']}>
      {props.tickets.map((ticket, index) => (
        <HeaderTicket
          key={index}
          {...ticket}
        />
      ))}
    </ul>
  );
};

HeaderTickets.displayName = 'HeaderTickets';

export default HeaderTickets;
